module.exports = __webpack_public_path__ + "static/media/double-down-arrow.66edd53b.svg";